import React, { useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { useParams } from 'react-router-dom';

import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import { tasksResolved } from '../../../../common/helpers';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';
import { useDecisionSubmit } from '../../decision/useDecisionSubmit';
import { InvalidDrawer } from '../InvalidDrawer';
import EditReinstatementDecision from './EditReinstatementDecision';
import SummaryReinstatementDecision from './SummaryReinstatementDecision';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default function DisagreeToReinstate() {
  const { id } = useParams<{ id: string }>();
  const [isOpen, setIsOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [isSummary, showSummary] = useState(false);

  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));
  const isValid = tasksResolved(tasks);
  const { submitCreate } = useDecisionSubmit(id || '', 'reinstate_disagree');

  function onConfirmClick() {
    if (id) {
      submitCreate({ description });
    }
    setIsOpen(false);
  }

  function onReviewClick() {
    showSummary(true);
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          labelCopy={Resource.DISAGREE_TO_REINSTATE}
        />
      )}
      {isValid &&
        (isSummary ? (
          <SummaryReinstatementDecision
            isOpen={isOpen}
            description={description}
            showSummary={showSummary}
            onConfirmClick={onConfirmClick}
            drawerName={Resource.DISAGREE_TO_REINSTATE}
          />
        ) : (
          <EditReinstatementDecision
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            description={description}
            setDescription={setDescription}
            showSummary={showSummary}
            onReviewClick={onReviewClick}
            drawerName={Resource.DISAGREE_TO_REINSTATE}
          />
        ))}
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faTimes}
        copy={Resource.DISAGREE_TO_REINSTATE}
        locator={ElementLocators.DECLINE_DECISION_LINK}
      />
    </>
  );
}
